import { Message } from '../components/Chat/type'
import RoomType from '../models/Room'

export interface RoomsState {
    room: RoomType | undefined
    roomsRun: RoomType[]
    roomsNotAttended: RoomType[]
    roomsRunTotal: number
    roomsNotAttendedTotal: number
    currentTab: number,
    visualizing: boolean,
    currentComponentListener: string | undefined,
}

export type RoomsAction =
    | { type: 'reload_all'; payload: any }
    | { type: 'reload_runs'; payload: any }
    | { type: 'reload_more_runs'; payload: RoomType[] }
    | { type: 'reload_not_attended'; payload: any }
    | { type: 'reload_more_not_attended'; payload: RoomType[] }
    | { type: 'set_room'; payload: any }
    | { type: 'set_rooms_run_total'; payload: any }
    | { type: 'set_rooms_not_attended_total'; payload: any }
    | { type: 'set_room_attended'; payload: any, uuid: string }
    | { type: 'set_room'; payload: any }
    | { type: 'update_room_in_list'; payload: RoomType }
    | { type: 'update_current_tab'; payload: number }
    | { type: 'set_visualizing'; }
    | { type: 'update_not_attended'; room: RoomType, user_id: number }
    | { type: 'activate_room'; room: RoomType }
    | { type: 'deactivate_room'; uuid: string }
    | { type: 'transfer_room'; uuid: string }
    | { type: 'incoming_transfer_room'; room: RoomType, user_id: number }
    | { type: 'update_room_status'; user_id: string, status: boolean }
    | { type: 'update_room_last_message'; uui: string, message: Message }
    | { type: 'set_current_component_listener'; payload: string }

export const roomsReducer = (state: RoomsState, action: RoomsAction) => {
    switch (action.type) {
        case 'set_current_component_listener':
            return { ...state, currentComponentListener: action.payload }
        case 'reload_all':
            return { ...state, ...action.payload }
        case 'reload_runs':
            return { ...state, ...action.payload }
        case 'reload_not_attended':
            return { ...state, ...action.payload }
        case 'reload_more_runs':
            state.roomsRun = state.roomsRun.concat(action.payload)
            return { ...state }
        case 'reload_more_not_attended':
            state.roomsNotAttended = state.roomsNotAttended.concat(action.payload)
            return { ...state }
        case 'update_room_in_list':
            state.roomsRun.concat(state.roomsNotAttended).filter(item => {
                if (item.id === action.payload.id) {
                    Object.assign(item, { ...action.payload })
                }
                return item
            })
            return { ...state }
        case 'update_room_status':
            state.roomsRun.concat(state.roomsNotAttended).filter(item => {
                if (item.user.id.toString() === action.user_id) {
                    Object.assign(item, { receiver_status: action.status })
                }
                return item
            })
            return { ...state }
        case 'update_room_last_message':
            state.roomsRun.concat(state.roomsNotAttended).filter(item => {
                if (item.uuid === action.uui) {
                    Object.assign(item, { last_message: action.message })
                }
                return item
            })
            return { ...state }
        case 'set_room':
            return { ...state, ...action.payload }
        case 'set_rooms_run_total':
            return { ...state, ...action.payload }
        case 'set_rooms_not_attended_total':
            return { ...state, ...action.payload }
        case 'update_current_tab':
            return { ...state, currenTab: action.payload }
        case 'set_visualizing':
            return { ...state, visualizing: !state.visualizing }
        case 'activate_room':
            if (action.room.attendant_id === undefined) {
                let exist = false
                state.roomsNotAttended.forEach((item, index) => {
                    if (item.uuid === action.room.uuid) {
                        exist = true
                    }
                })
                if (!exist) {
                    state.roomsNotAttended.push(action.room)
                    state.roomsNotAttendedTotal++
                }

            }

            return { ...state }
        case 'incoming_transfer_room':
            let exist = false
            state.roomsRun.forEach((item, index) => {
                if (item.uuid === action.room.uuid) {
                    exist = true
                }
            })
            if (!exist) {
                state.roomsRun.unshift(action.room)
                state.roomsRunTotal++
            }

            if (state.room?.uuid === action.room.uuid) {
                state.room = action.room
            }

            state.roomsNotAttended.forEach((item, index) => {
                if (item.uuid === action.room.uuid) {
                    state.roomsNotAttended.splice(index, 1)
                    state.roomsNotAttendedTotal--
                }
            })

            return { ...state }
        case 'deactivate_room':
            state.roomsRun.forEach((item, index) => {
                if (item.uuid === action.uuid) {
                    state.roomsRun.splice(index, 1)
                    state.roomsRunTotal--
                }
            })
            if (state.room?.uuid === action.uuid) {
                state.room = undefined
            }

            return { ...state }
        case 'transfer_room':
            state.roomsRun.forEach((item, index) => {
                if (item.uuid === action.uuid) {
                    state.roomsRun.splice(index, 1)
                    state.roomsRunTotal--
                }
            })
            if (state.room?.uuid === action.uuid) {
                state.room = undefined
            }

            return { ...state }
        case 'update_not_attended':
            if (action.room.attendant_id) {
                if (state.room?.attendant_id !== action.user_id) {
                    state.roomsNotAttended.forEach((item, index) => {
                        if (item.uuid === action.room.uuid) {
                            state.roomsNotAttended.splice(index, 1)
                            state.roomsNotAttendedTotal--
                        }
                    })
                }
                if (state.room?.uuid === action.room.uuid) {
                    if (state.room.attendant_id === action.user_id) {
                        state.room = action.room
                    } else {
                        state.room = undefined
                    }
                }

            } else {
                const exist = state.roomsNotAttended.filter(item => {
                    return item.uuid === action.room.uuid
                })
                if (exist.length === 0) {
                    state.roomsNotAttended.push(action.room)
                    state.roomsNotAttendedTotal++
                }
                state.roomsRun.forEach((item, index) => {
                    if (item.uuid === action.room.uuid) {
                        state.roomsRun.splice(index, 1)
                        state.roomsRunTotal--
                    }
                })
                if (state.room?.uuid === action.room.uuid) {
                    if (action.room.attendant_id === action.user_id) {
                        state.room = action.room
                    } else {
                        state.room = undefined
                    }
                }
            }

            return { ...state }
        case 'set_room_attended':
            if (action.payload !== undefined) {
                state.roomsNotAttended.forEach((item, index) => {
                    if (state.room?.uuid === action.uuid) {
                        state.room.attendant = action.payload
                        state.room.attendant_id = action.payload.id
                    }
                    if (item.uuid === action.uuid) {
                        item.attendant = action.payload
                        item.attendant_id = action.payload.id
                        state.roomsNotAttended.splice(index, 1)
                        state.roomsNotAttendedTotal--
                        state.currentTab = 0
                    }
                })

            } else {
                state.roomsRun.forEach((item, index) => {
                    if (item.uuid === action.uuid) {
                        item.attendant = action.payload
                        state.roomsRun.splice(index, 1)
                        state.roomsRunTotal--
                    }
                })
            }
            return { ...state }
        default:
            return state
    }
}

export const roomsInitialState = {
    room: undefined,
    roomsRun: [],
    roomsNotAttended: [],
    roomsRunTotal: 0,
    roomsNotAttendedTotal: 0,
    currentTab: 0,
    visualizing: true,
    currentComponentListener: undefined
}